<template>
    <div class="chartContainer">
        <p>Tagesverlauf</p>
        <line-chart :data="graphData()"
                    suffix=" W"
                    :points="false"
                    :curve="false"
                    :colors="['#ffffff']"
                    :dataset="{color: 10}"
                    :library="library"/>
    </div>
</template>

<style>

    .chartContainer {
        width: 100%;
        height: 400px;
    }

</style>

<script>
    import store from '../../services/VuexStore';
    import moment from 'moment-timezone';

    export default {
        name: 'DailyGraph',
        components: {},
        data () {
            return {
                library: {
                    legend: {
                        display: false,
                    },
                    datasets: {
                        borderColor: 'rgba(1,1,1,1)',
                        backgroundColor: 'rgba(1,1,1,1)',
                    },
                    scales: {
                        xAxes: [
                            {
                                type: 'time',
                                time: {
                                    unit: 'minute',
                                    displayFormats: {
                                        minute: 'H:mm',
                                        hour: 'H',
                                    },
                                    min: ((new Date()).setUTCHours(6, 0, 0, 0)),
                                    max: ((new Date()).setUTCHours(20, 0, 0, 0)),
                                },
                                ticks: {
                                    fontColor: '#CCC',
                                },
                                parser: function (utcMoment) {
                                    return utcMoment.utcOffset('+0000');
                                },
                            }],
                        yAxes: [
                            {
                                gridLines: {
                                    display: true,
                                    color: 'rgba(255,255,255,0.2)',
                                },
                                ticks: {
                                    min: 0, // minimum value
                                    max: 15000, // maximum value
                                    fontColor: '#CCC',
                                },
                            }],
                    },
                },
            };
        },
        methods: {
            graphData: function () {
                let graph = {};

                if (!store.state.granularToday) {
                    return {};
                }

                for (let i in store.state.granularToday) {
                    let data = store.state.granularToday[i];

                    graph[data.datetime + 'Z'] = data.energy;
                }

                return graph;
            },
        },
        mounted () {
            moment.tz.setDefault('UTC');
        },
    };
</script>